import i18n from 'i18nextInstance';
import { officeActions } from '.';
import officeServices from './services';
import { push } from 'react-router-redux';
import {
    call,
    put,
    takeEvery
} from 'redux-saga/effects';

function* _getOffice ({ payload }) {
    try {
        yield put(officeActions.setOfficeLoading(true));
        const { data } = yield call(officeServices.getOffice, { id: payload });
        yield put(officeActions.setOfficeSelected(data));
    } catch (e) {

    } finally {
        yield put(officeActions.setOfficeLoading(false));
    }
}

function* _getOfficePage ({ payload = {} }) {
    try {
        yield put(officeActions.setOfficePageLoading(true));
        const { data } = yield call(officeServices.fetchOfficePage, null, payload);
        yield put(officeActions.setOfficePage({
            ...data,
            filters: payload
        }));
    } catch (e) {

    } finally {
        yield put(officeActions.setOfficePageLoading(false));
    }
}

function* _getOfficeListing ({ payload }) {
    try {
        yield put(officeActions.setOfficeLoading(true));
        const params = {
            ...(payload && { doctor_id: payload })
        };
        const { data } = yield call(officeServices.getOfficesList, null, params);
        const parsedData = data.map(office => {
            const { doctor, id, name } = office;
            return ({
                ...office,
                label: `${ name }${ !!doctor ? ` (${ doctor.last_name }, ${ doctor.first_name })` : '' }`,
                value: id
            });
        });
        yield put(officeActions.setOfficeList(parsedData));
    } catch (e) {

    } finally {
        yield put(officeActions.setOfficeLoading(false));
    }
}

function* _officeDelete ({ payload }) {
    try {
        yield put(officeActions.setOfficeLoading(true));
        yield call(officeServices.deleteOffice, { id: payload });
        yield put(push(i18n.t('/consultorios/listar')));
    } catch (e) {

    } finally {
        yield put(officeActions.setOfficeLoading(true));
    }
}

function* _officeRestore ({ payload }) {
    try {
        yield put(officeActions.setOfficeLoading(true));
        yield call(officeServices.restoreOffice, { id: payload });
        yield put(push(i18n.t('/consultorios/listar')));
    } catch (e) {

    } finally {
        yield put(officeActions.setOfficeLoading(true));
    }
}

function* _officeRegistration ({ payload }) {
    try {
        yield put(officeActions.setOfficeLoading(true));
        const { id, ...body } = payload;
        if (!id) {
            yield call(officeServices.postOffice, null, body);
        } else {
            yield call(officeServices.putOffice, { id }, body);
        }
        
        yield put(push(i18n.t('/consultorios/listar')));
    } catch (e) {

    } finally {
        yield put(officeActions.setOfficeLoading(false));
    }
}

export default [
    takeEvery(officeActions.getOffice.type, _getOffice),
    takeEvery(officeActions.getOfficeListing.type, _getOfficeListing),
    takeEvery(officeActions.getOfficePage.type, _getOfficePage),
    takeEvery(officeActions.officeDelete.type, _officeDelete),
    takeEvery(officeActions.officeRestore.type, _officeRestore),
    takeEvery(officeActions.officeRegistration.type, _officeRegistration)
];
